import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../config";

function Dashboard() {
    const navigate = useNavigate();

    const [stats, setStats] = useState({
        farmers: 0,
        users: 0,
        products: 0,
        routes: 0,
        milk_price: 0,
        unpaid_debts: 0,
        unpaid_amount: 0,
        paid_amount: 0,
        liters_this_month: 0,
        milk_value_this_month: 0,
        liters_last_month: 0,
        milk_value_last_month: 0,
        treatmentAndAi: {
            this_month: 0,
            last_month: 0
        },
        advance: {
            this_month: 0,
            last_month: 0
        }
    });

    console.log("User Role:", localStorage.getItem('userRole'));

    const fetchDashboardStats = useCallback(async () => {
        try {
            const token = localStorage.getItem("access_token");

            if (!token) {
                navigate("/logout");
                return;
            }

            const response = await fetch(`${API_URL}/dashboard`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            if (response.ok) {
                const data = await response.json();
                setStats(data);
            } else if (response.status === 401) {
                navigate("/logout");
            } else {
                console.error("Failed to fetch dashboard stats", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching dashboard stats:", error);
        }
    }, [navigate]);

    useEffect(() => {
        fetchDashboardStats();
    }, [fetchDashboardStats]);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'KES' 
        }).format(amount);
    };

    const formatNumber = (num) => {
        return new Intl.NumberFormat('en-US').format(num);
    };

    return (
        <div>
            <main>
                <div className="columns">
                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">TOTAL FARMERS</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatNumber(stats.farmers)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>

                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">SYSTEM USERS</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatNumber(stats.users)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>

                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">PRODUCTS</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatNumber(stats.products)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>

                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">ROUTES</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatNumber(stats.routes)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="columns">
                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">CURRENT MILK PRICE</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatCurrency(stats.milk_price)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>

                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">UNPAID DEBTS</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatCurrency(stats.unpaid_debts)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>

                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">UNPAID AMOUNT</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatCurrency(stats.unpaid_amount)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>

                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">PAID AMOUNT</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatCurrency(stats.paid_amount)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="columns">
                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">THIS MONTH'S LITERS</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatNumber(stats?.liters_this_month)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>

                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">THIS MONTH'S MILK VALUE</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatCurrency(stats.milk_value_this_month)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>

                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">LAST MONTH'S LITERS</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatNumber(stats.liters_last_month)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>

                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">LAST MONTH'S MILK VALUE</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatCurrency(stats.milk_value_last_month)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>
                </div>

                 <div className="columns">
                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">TREATMENT & AI - THIS MONTH</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatCurrency(stats.treatmentAndAi?.this_month)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>

                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">TREATMENT & AI - LAST MONTH</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatCurrency(stats.treatmentAndAi?.last_month)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>

                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">Advance This MONTH</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatCurrency(stats.advance?.this_month)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>

                    <div className="column is-3">
                        <div className="card p-4">
                            <p className="dash-card-title">Advance LAST MONTH</p>
                            <div className="card-content has-text-weight-semibold pl-0 pr-0">
                                <p className="title">{formatCurrency(stats.advance?.last_month)}</p>
                                <hr />
                            </div>
                        </div>
                    </div>

                </div>

            </main>
        </div>
    );
}

export default Dashboard;
